<div [class.dragover]="dragOver()" [class.uploading]="uploading()" class="dialog-container">
    <div class="d-flex justify-content-between align-items-center" mat-dialog-title>
        <h1 class="condensed">
            {{fileRequired() ? 'Bestand' : 'Hoofdstuk'}}
            {{!fileRequired() && !noFilesAllowed() ? 'of bestand' : ''}} toevoegen
        </h1>
    </div>
    <div class="dialog-content mt-3" mat-dialog-content>
        <form [formGroup]="form">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Naam</mat-label>
                <input formControlName="name" id="name" matInput name="name" placeholder="Naam" type="text">
                <mat-error>Dit veld mag maximaal 255 tekens bevatten</mat-error>
            </mat-form-field>
            @if (file()) {
                <div>
                    <b>Geüpload bestand:</b> {{file()}}
                    <br>
                </div>
            }
        </form>
        @if (!file() && !noFilesAllowed()) {
            <div>
                Geen bestand toegevoegd
                <button color="primary" mat-button style="padding: 0">
                    <label style="margin: 0; padding: 0 16px;">
                        Bestand uploaden <input (change)="uploadFile($event)" hidden multiple type="file">
                    </label>
                </button>
            </div>
        }
        @if (!noFilesAllowed() && !fileRequired()) {
            <small>Upload geen bestand om een hoofdstuk toe te voegen</small>
        }

    </div>
    <div class="d-flex flex-wrap pt-2 justify-content-between" mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">Annuleren</button>
        <div class="spacer"></div>
        <button (click)="save()" [disabled]="saving() || !form.valid" cdkFocusInitial color="primary" mat-raised-button>
            Opslaan
            @if (saving()) {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </button>
    </div>
    <div class="overlay">
        <div class="overlay-wrapper drag">
            <div class="upload-icon">
                <i class="fas fa-upload"></i>
            </div>
        </div>
        <div class="overlay-wrapper uploading">
            <div class="upload-icon">
                <i class="fas fa-circle-notch fa-spin"></i>
            </div>
            <div>
                Bezig met uploaden...
            </div>
        </div>
    </div>
</div>
